import React from 'react';

import { LogoStyled } from './Logo.styled';
import { ProjectCareLogo } from './ProjectCareLogo';

export const Logo = ({ isMobile }) => {
  return (
    <LogoStyled isMobile={isMobile}>
      <ProjectCareLogo className='projectCareLogo'/>
    </LogoStyled>
  )
}
